import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Home from '@/pages/home/page';
import Todo from '@/pages/todo/page';
import Projects from '@/pages/projects/page';
import ProjectDetail from '@/pages/projects/detail';
import Finance from '@/pages/finance/page';
import FinanceDetail from '@/pages/finance/detail';
import Profile from '@/pages/profile/page';
import AppLayout from '@/components/feature/AppLayout';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'todo',
        element: <Todo />,
      },
      {
        path: 'projects',
        element: <Projects />,
      },
      {
        path: 'projects/:id',
        element: <ProjectDetail />,
      },
      {
        path: 'finance',
        element: <Finance />,
      },
      {
        path: 'finance/:id',
        element: <FinanceDetail />,
      },
      {
        path: 'profile',
        element: <Profile />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;